export enum SmallDistanceUnit {
  MM = 'MM',
  IN_1_32 = 'IN_1_32',
}

export enum LargeDistanceUnit {
  KM = 'KM',
  MI = 'MI',
}

export const LargeDistanceUnitName = {
  [LargeDistanceUnit.KM]: 'kilometer',
  [LargeDistanceUnit.MI]: 'mile',
};
